import React from 'react';
import { Icon } from './Icon';

/** Frosted search field. Ported from D:\campaigning-system\src\components\ui\SearchInput.tsx. */
export function SearchInput({ value, onChange, placeholder = 'Search…', className = '' }) {
  return (
    <label
      className={`flex items-center gap-2 rounded-xl border border-cos-line bg-white/60 px-3 py-2 text-sm transition-all duration-200 focus-within:border-cos-teal focus-within:shadow-cos-teal-glow ${className}`}
    >
      <Icon name="search" className="text-[19px] text-cos-ink-muted" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full border-0 p-0 shadow-none focus:ring-0 focus:!shadow-none bg-transparent text-cos-ink placeholder:text-cos-ink-muted focus:outline-none"
      />
      {value && (
        <button type="button" onClick={() => onChange('')} aria-label="Clear search" className="text-cos-ink-muted hover:text-cos-ink">
          <Icon name="close" className="text-[17px]" />
        </button>
      )}
    </label>
  );
}

export default SearchInput;
